import React from 'react';

const CustomLogo = ({ className = "", width = "auto", height = "60" }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 5243.9 5696.8"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
  >
    <defs>
      <linearGradient
        id="logoGradient"
        x1="4310.2"
        y1="4935.9"
        x2="4516.5"
        y2="5082.1"
        gradientTransform="translate(-75540.1 95432.5) rotate(0) scale(18.1 -18.1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#f7ff00" />
        <stop offset="1" stopColor="#fc8a0d" />
      </linearGradient>
    </defs>
    <g transform="matrix(1, 0, 0, 1, -2060.495605, -1754.399902)">
      <path
        fill="url(#logoGradient)"
        d="M5674.3,2066.1c7.5,8.3-7.6,43.2-11.2,55.3l-204.4,693-448.4,1445.2-133.5,427.5-26.9,86.2c-4.6,13.7-13.7,29.4-14.3,43.6,39.2-5,81.5-2.3,121-2.6l211.5-1.3,700.7-.8-2253.5,2419.2-2.6.7-3.3-6.4,879.3-2723.3c-41.9,4.7-85.6.7-127.8.2l-200.8-.6-703.5.8c29.2-60.7,77.9-116,119.8-168.4l193.2-233.7,1095.2-1207.9,392-416.8,117.4-126.2,118.8-110.1c60.2-57.8,116.4-121,181.3-173.6Z"
      />
      <path
        fill="#171bb6"
        d="M4226.7,1922.6l5.9,5.8-1.9,851.6-.5,221.7c-.2,31.2,4,71.6-4.8,101.5-5.6,18.9-22.6,34.7-35.5,49.2l-72.4,83-243.5,289-319.7,376.2-300.5,341.9-343.5,447-81.2,116.2,4.9.2c46.1-3.8,93.6-.6,140-.3l234.4.5,882.3-.7-320.9,970.4c-34.2,8.1-26.3,1.2-62,1l-362.7-1c-72.8.4-147.4,3.1-220.1-2.3-259.5-19.1-491.4-118.4-685.4-291.6-221.2-197.4-361.2-474.7-377.2-772.1-11.3-208.5,27.1-421.2,130.5-604.2,90.9-160.9,237.9-300.9,365.1-434.3l298.4-313.9,814.1-855.8,251.3-262.1,305-316.8Z"
      />
      <path
        fill="#171bb6"
        d="M5548.3,3549.3c48.9,8.4,105.3,3.8,155.2,3.8h275.6c105.8.1,214.4-4,319.8,4.6,253.4,20.6,481.8,122.2,661.5,297.5,222.7,217.1,345.7,522.4,344,827.9-1.2,218.6-58,427.7-175.3,614.9-77.9,124.2-188.9,228.5-292.1,332.8l-342.8,344-1191.1,1184.6-236.8,235,5.3-1177.3c1.7-17.3,7.9-30.4,18-44.5,84.5-116.6,187.1-224.8,280.1-335.4l720.7-829.4,271.1-304.4c50.5-56.9,165.3-177.2,165.3-177.2l-2.1-6.8c-39,5.9-84,.8-123.6.5l-232.2-.7h-929.1c-4.5-20.2,276.5-877.2,308.4-969.8Z"
      />
      <polyline
        fill="#171bb6"
        points="7067.6,5371.2 5066.4,7451.2 5071.5,6228 6451.6,5945.4"
      />
      <polyline
        fill="#171bb6"
        points="2192.8,4105.4 4232.6,1754.4 4225.2,3046.4"
      />
      <polyline
        fill="#171bb6"
        points="2386.1,3851.1 4232.6,1754.4 4225.2,3103.2"
      />
    </g>
  </svg>
);

export default CustomLogo;

